import { MagnifyingGlassIcon, PlusIcon } from "@heroicons/react/24/outline";
export default function TeamMemberManagement() {
	const members = [
		{
			id: 1,
			name: "Shilpa G",
			email: "shgopal@gmail.com",
			role: "Owner",
			status: "Active",
			avatar:
				"https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=64&h=64",
		},
	];

	return (
		<div className="min-h-screen bg-gray-50 p-6">
			<div className="mx-auto max-w-6xl">
				{/* Header */}
				<div className="flex items-center justify-between">
					<div>
						<h1 className="text-2xl font-semibold text-gray-900">Your Team</h1>
						<p className="mt-1 text-sm text-gray-500">
							Manage your team in one place
						</p>
					</div>
					<button className="inline-flex items-center gap-2 rounded-lg bg-black px-4 py-2 text-sm font-medium text-white hover:bg-gray-800">
						<PlusIcon className="h-4 w-4" />
						Invite Member
					</button>
				</div>

				{/* Card */}
				<div className="mt-6 rounded-2xl bg-white shadow">
					<div className="border-b border-gray-200 px-6 py-4">
						<h2 className="text-sm font-medium text-gray-900">
							Team Directory
						</h2>
					</div>

					{/* Search */}
					<div className="px-6 py-4">
						<div className="relative max-w-sm">
							<MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
							<input
								type="text"
								placeholder="Search"
								className="w-full rounded-lg border border-gray-300 pl-9 pr-3 py-2 text-sm focus:border-black focus:outline-none focus:ring-1 focus:ring-black"
							/>
						</div>
					</div>

					{/* Table */}
					<div className="overflow-x-auto">
						<table className="min-w-full divide-y divide-gray-200">
							<thead className="bg-gray-50">
								<tr>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500">
										Name
									</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500">
										Status
									</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500">
										Role (with Access button)
									</th>
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500">
										Email
									</th>
								</tr>
							</thead>
							<tbody className="divide-y divide-gray-100 bg-white">
								{members.map((member) => (
									<tr key={member.id} className="bg-blue-50/40">
										<td className="px-6 py-4">
											<div className="flex items-center gap-3">
												<img
													src={member.avatar}
													alt=""
													className="h-9 w-9 rounded-full"
												/>
												<span className="text-sm font-medium text-gray-900">
													{member.name}
												</span>
											</div>
										</td>
										<td className="px-6 py-4">
											<span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
												<span className="h-2 w-2 rounded-full bg-green-500" />
												{member.status}
											</span>
										</td>
										<td className="px-6 py-4">
											<span className="inline-flex rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-700">
												{member.role}
											</span>
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											{member.email}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
}
